const subcollectionsSlidercontainer = document.querySelector(
	'.subcollections__slider'
)

if (subcollectionsSlidercontainer) {
	var swiper = new Swiper('.subcollections__slider', {
		simulateTouch: true,
		grabCursor: true,
		spaceBetween: 15,
		slidesOffsetBefore: 16,
		slidesOffsetAfter: 16,
		slidesPerView: 2.75,
		centerInsufficientSlides: true,
		speed: 600,
		navigation: {
			nextEl: '.subcollections__button-next',
			prevEl: '.subcollections__button-prev',
		},
		mousewheel: false,
		keyboard: true,
		slidesPerGroupAuto: true,
		slidesPerGroupSkip: 0,
		breakpoints: {
			320: {
				slidesPerView: 3.7,
				spaceBetween: 10,
			},
			640: {
				slidesPerView: 4.5,
				spaceBetween: 30,
			},
			970: {
				slidesPerView: 5.5,
			},
			1070: {
				slidesPerView: 6.5,
			},
			1300: {
				slidesPerView: 'auto',
			},
		},
		pagination: {
			el: '.swiper-pagination',
			clickable: true,
		},
		on: {
			slideNextTransitionStart: function () {
				if (
					this.slides.length - 1 ==
					this.snapIndex + parseInt(this.params.slidesPerView)
				) {
					this.slideTo(this.slides.length)
				}
			},
		},
	})
}
